// extracted by mini-css-extract-plugin
export default {"opporunityForm":"OpportunityForm_opporunityForm__5gdps","grouping":"OpportunityForm_grouping__ZPT-m"};